import { useAuth } from "@clerk/nextjs";
import { useQuery } from "@tanstack/react-query";
import { getAskPaperThread } from "helpers/api";

function useAskPaperThread(paperId: string) {
  const { isSignedIn, isLoaded } = useAuth();

  return useQuery(
    ["ask-paper", paperId],
    async () => {
      const res = await getAskPaperThread(paperId);

      // Messages are returned in order of recency.
      // Reverse the list to get it in coversation order.
      return res.messages.reverse();
    },
    {
      enabled: Boolean(paperId) && isLoaded && isSignedIn,
      staleTime: Infinity,
    }
  );
}

export default useAskPaperThread;
